<template>
  <Layout :is-loading="status === 'pending' || status === 'error'">
    <template #default>
      <TheMainContent>
        <Checkout v-if="data" :policy-id :total-price="data?.payment.total" />
      </TheMainContent>
    </template>

    <template #aside>
      <div class="space-y-24">
        <h2 class="heading-3">{{ i18n(translations.summaryTitle) }}</h2>

        <DueSummary v-if="data" :payment="data.payment" :policy="data.policy" />
      </div>
    </template>
  </Layout>
</template>

<script setup lang="ts">
import { createError, navigateTo, useAsyncData, useRouteParams } from '#imports'
import { watchEffect } from 'vue'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'
import Layout from '~/scopes/insurance/components/Layout/Layout.vue'

import { INSURANCE } from '../../routes.constants'

import translations from './DueInsurance.translations'
import Checkout from './components/Checkout/Checkout.vue'
import DueSummary from './components/DueSummary/DueSummary.vue'

const i18n = useI18n()
const { policyId } = useRouteParams()
const $httpFetch = useHttpFetch()

type DuePaymentResponse =
  ApiSpecs['/bm/insurances/v2/policies/:policyId/due-payments']['GET']['response']
type DuePaymentError = {
  type: string
  title: string
}

const { data, error, status } = useAsyncData<
  DuePaymentResponse,
  DuePaymentError
>(() =>
  $httpFetch('/bm/insurances/v2/policies/:policyId/due-payments', {
    method: 'GET',
    pathParams: { policyId },
  }),
)

watchEffect(() => {
  if (error.value) {
    if (
      error.value.statusCode === 400 &&
      error.value.data?.type === '/errors/insurance/no-missed-occurrences'
    ) {
      void navigateTo({ name: INSURANCE.DUE_PAYMENT_COMPLETED })
    } else {
      throw createError({
        statusCode: error.value.statusCode,
        message: error.value.data?.title,
      })
    }
  }
})
</script>
